export const GET_USER_PROFILE_SUCCESSFUL = "GET_USER_PROFILE_SUCCESSFUL";

export const GET_USER_PROFILE_PROCESSING = "GET_USER_PROFILE_PROCESSING";

export const STOP_GET_USER_PROFILE_PROCESSING = "STOP_GET_USER_PROFILE_PROCESSING";
export const GET_ALL_PROFILE = "GET_ALL_PROFILE";
